import * as React from 'react';
import { Button, Collapse, DropdownItem, DropdownMenu, DropdownToggle, Navbar, NavbarToggler, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap';
import './ConsoleNavMenu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faSpinner, faUser } from '@fortawesome/pro-light-svg-icons';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators, Dispatch } from 'redux';
import { logout } from '../../ApiUtils/ApiUtils';
import { ApplicationState } from '../../store';
import * as ConsoleStore from '../../store/Console';
import { getUsersByRoleName } from '../../ApiUtils/ApiUtils';

type ConsoleNavMenuProps = {
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

type ConsoleNavMenuState = {
    isOpen: boolean
}

class ConsoleNavMenu extends React.PureComponent<ConsoleNavMenuProps, ConsoleNavMenuState> {
    constructor(props: ConsoleNavMenuProps) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.props.consoleActions.getUserProfile();
    }

    private handleLogout = () => {
        logout().then(response => {
            document.open();
            document.write(response);
            document.close();
        });
    }

    private displayFirstName = () => {
        const userProfile = this.props.console?.userProfileState.userProfile;
        let firstName = userProfile?.firstName?.trim() || "";

        if (firstName !== "") {
            firstName = ", " + firstName;
        }

        return (this.props.console?.userProfileState.isLoading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
            <span>{firstName}</span>
        ));
    }

    private displayUserName = () => {
        return (this.props.console?.userProfileState.isLoading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
            <span>{this.props.console?.userProfileState.userProfile.email}</span>
        ));
    }

    private displayName = () => {
        const userProfile = this.props.console?.userProfileState.userProfile;
        const firstName = userProfile?.firstName?.trim() || "";
        const lastName = userProfile?.lastName?.trim() || "";
        const displayName = firstName || lastName ? `${firstName} ${lastName}`.trim() : "";

        return (this.props.console?.userProfileState.isLoading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
                <span>{displayName}</span>
        ));
    }

    private displayUserInitials = () => {
        const userProfile = this.props.console?.userProfileState.userProfile;
        const firstNameInitial = userProfile?.firstName?.trim() ? userProfile.firstName.charAt(0).toUpperCase() : "";
        const lastNameInitial = userProfile?.lastName?.trim() ? userProfile.lastName.charAt(0).toUpperCase() : "";
        return firstNameInitial || lastNameInitial ? `${firstNameInitial}${lastNameInitial}` : "";
    }

    public render() {

        return (
            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow console-navbar" light style={{ height: "50px"}}>
                <h5 style={{ padding: "16px 8px 8px 16px", margin: "0" }}>Welcome{this.displayFirstName()}!</h5>
                <NavbarToggler onClick={this.toggle} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                    <ul className="navbar-nav flex-grow userinfo">
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav>
                                <Button className="btn btn-outline-light profile-button box-shadow border border-secoondary" style={{ "backgroundColor": "#f5f5f5" }}>
                                    {this.displayUserInitials()}
                                </Button>
                            </DropdownToggle>
                            <DropdownMenu end>
                                <DropdownItem onClick={this.handleLogout}>
                                    <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        <NavItem className="d-flex flex-column justify-content-center align-items-start" style={{ height: "100%" }}>
                            <NavLink className="p-0 display-name">
                                {this.displayName()}
                            </NavLink>
                            <NavLink className="p-0 display-user">
                                {this.displayUserName()}
                            </NavLink>
                        </NavItem>
                    </ul>
                </Collapse>
            </Navbar>
        );
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsoleNavMenu);
